export default __webpack_public_path__ + "static/media/Dhara.f493b535.jpeg";